import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ScrollAnimate {

  constructor () {
    this.tweens = []
    this.batchTweens = []
    this.offset = 100
  }

  init () {
    this.createTweens()
    this.createBatch()
  }

  createTweens () {

    const items = gsap.utils.toArray(document.querySelectorAll('.js-animate'))

    items.forEach((el, i) => {

      // if (ScrollTrigger.isInViewport(el, 0.1) && window.scrollY === 0) return;

      const delay = el.getAttribute('data-delay')
      const elOffset = el.getAttribute('data-offset')
      
      let offset = null

      if (elOffset) {
        offset = elOffset
      } else {
        offset = this.offset
      }

      if (delay) el.style.transitionDelay = delay + 'ms'

      this.tweens[i] = ScrollTrigger.create({
        trigger: el,
        start: () => `top bottom-=${offset}px`,
        once: true,
        onEnter: () => { el.setAttribute('data-animated', 'true') },
        scroller: !document.body.classList.contains('enable-smooth-scroll') || document.body.classList.contains('mobile') ? window : '.smooth-scroll'
      })
    });
  }

  createBatch () {
    const batchContainer = document.querySelectorAll('.js-batch-container')

    if (!batchContainer.length) return;

    const items = gsap.utils.toArray(batchContainer)
    
    items.forEach( (el, i) => {

      const batchs = el.querySelectorAll('.js-batch')

      // batchs.forEach(el => {
      //   if (ScrollTrigger.isInViewport(el, 0.1)) {
      //     el.classList.add('disable-animation')
      //   }
      // })

      const elStagger = el.getAttribute('data-stagger')

      let stagger = 0.3

      if (elStagger) {
        stagger = elStagger
      }
      
      ScrollTrigger.batch(batchs, {
        onEnter: batch => {
          gsap.to(batch, { stagger: stagger, attr: { 'data-animated': 'true' } })
        },
        id: 'st-batch',
        interval: 0.1,
        once: true,
        scroller: !document.body.classList.contains('enable-smooth-scroll') || document.body.classList.contains('mobile') ? window : '.smooth-scroll'
      })
    })
  }

  destroy () {

    if (this.tweens.length) {
      this.tweens.forEach(el => el.kill()) 
      this.tweens = []
    }

    ScrollTrigger.getAll().forEach(st => st.vars.id === "st-batch" && st.kill());

  }

}

